import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone } from "lucide-react";
import { api } from "@/lib/api";
import { useSearch } from "@/context/SearchContext";

function SponsorAd({ state }) {
  const [ads, setAds] = useState([]);
  useEffect(() => {
    if (!state) { setAds([]); return; }
    api.get("/sponsors/active", { params: { state } }).then((r) => setAds(r.data)).catch(() => setAds([]));
  }, [state]);
  if (!ads.length) return null;
  const ad = ads[Math.floor(Date.now() / 60000) % ads.length];
  const img = <img src={ad.image_url} alt={`${ad.business_name} ad`} className="h-28 w-full rounded-xl object-cover sm:h-36" />;
  return (
    <div data-testid="footer-sponsor-ad" className="mb-8">
      <p className="eyebrow mb-2 text-zinc-500">Sponsored · {ad.business_name}</p>
      {ad.link_url ? <a href={ad.link_url} target="_blank" rel="noopener noreferrer sponsored">{img}</a> : img}
    </div>
  );
}

export function Footer() {
  const { origin } = useSearch();
  return (
    <footer className="border-t border-zinc-800 bg-[#09090c]">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6">
        <SponsorAd state={origin?.state} />
        <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <img src="/logo192.png" alt="" className="h-8 w-8 rounded-lg" />
              <span className="font-heading logo-glow text-3xl">My Happy Hour</span>
            </div>
            <p className="mt-2 max-w-sm text-sm text-zinc-500">Free happy hour finder. Specials change, so check with the venue before you go.</p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link to="/advertise" data-testid="footer-advertise-link" className="flex items-center gap-2 rounded-full bg-[#fde68a] px-5 py-2.5 text-sm font-bold text-zinc-950 transition-transform hover:-translate-y-0.5">
              <Megaphone size={16} /> Want to Advertise?
            </Link>
            <Link to="/submit" data-testid="footer-submit-link" className="rounded-full border border-zinc-700 px-5 py-2.5 text-sm font-semibold text-zinc-300 hover:text-white">Own a Bar? Submit Specials</Link>
            <Link to="/featured" data-testid="footer-featured-link" className="rounded-full border border-zinc-700 px-5 py-2.5 text-sm font-semibold text-zinc-300 hover:text-white">Get Featured</Link>
          </div>
        </div>
        <p className="mt-8 text-xs text-zinc-600">© {new Date().getFullYear()} myhappyhour.site · Drink responsibly.</p>
      </div>
    </footer>
  );
}
